import { CDN_URL, ENV } from "../settings";
import { sanitizeUrl } from "./sanitizeUrl";

const DEFAULT_LOGO_HOMOLOG = 'companies-logos/01JWC2TZT0ZBDW3675WMY9CGAZ.png';
const DEFAULT_LOGO_PROD = 'companies-logos/01J3DH3EP50KBVSWHSVRRJFHSS.png';

const isAbsoluteUrl = (url: string): boolean => {
  return url.startsWith('http') || url.startsWith('blob');
};

export const buildCdnPath = (path: string): string => {
  return `${CDN_URL}/${path}`;
};

const getFallback = (): string => {
  const isProd = ENV === 'production';
  return isProd ? DEFAULT_LOGO_PROD : DEFAULT_LOGO_HOMOLOG;
};

export const resolveAssetUrl = (path?: string, fallbackUrl?: string): string | undefined => {
  if (!path) {
    return buildCdnPath(fallbackUrl || getFallback());
  }

  if (isAbsoluteUrl(path)) {
    return sanitizeUrl(path);
  }

  return buildCdnPath(path);
};
